import React from 'react'

export default function Header() {
    return (
        <div id= 'main'>
            <div className='header-heading'>

    
            <h1> <span>DA</span>DA<br/>SHI</h1>
           

     

            
            </div>

        </div>
    )
}
